import { render, staticRenderFns } from "./pbrCenterDY.vue?vue&type=template&id=21ce87fe&scoped=true"
import script from "./pbrCenterDY.vue?vue&type=script&lang=js"
export * from "./pbrCenterDY.vue?vue&type=script&lang=js"
import style0 from "./pbrCenterDY.vue?vue&type=style&index=0&id=21ce87fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce87fe",
  null
  
)

export default component.exports